import React from 'react';
import { useTranslation } from '../../contexts/LanguageContext';
import { BOARD_THEMES } from './SettingsData';

const BoardThemeSelector = ({ 
  boardTheme, 
  setBoardTheme, 
  customBoardLight,
  setCustomBoardLight,
  customBoardDark,
  setCustomBoardDark,
  useCustomBoard,
  setUseCustomBoard
}) => {
  const { t } = useTranslation();

  return (
    <section className="settings-section board-theme-section">
      <h3>🎨 {t('settings.boardTheme', 'Board Theme')}</h3>
      
      <div className="theme-selector">
        <h4>{t('settings.presetThemes', 'Preset Themes')}:</h4>
        <div className="theme-grid">
          {BOARD_THEMES.map(theme => (
            <button
              key={theme.id}
              className={`theme-button ${boardTheme === theme.id && !useCustomBoard ? 'active' : ''}`}
              onClick={() => {
                setBoardTheme(theme.id);
                setUseCustomBoard(false);
              }}
            >
              <div className="theme-preview">
                <div className="theme-square" style={{ backgroundColor: theme.light }}></div>
                <div className="theme-square" style={{ backgroundColor: theme.dark }}></div>
              </div>
              <span>{theme.name}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="custom-colors">
        <h4>{t('settings.customColors', 'Custom Colors')}:</h4>
        <div className="color-pickers">
          <div className="color-picker-item">
            <label>{t('settings.lightSquares', 'Light Squares')}:</label>
            <input
              type="color"
              value={customBoardLight}
              onChange={(e) => {
                setCustomBoardLight(e.target.value);
                setUseCustomBoard(true);
              }}
            />
            <span className="color-value">{customBoardLight}</span>
          </div>
          <div className="color-picker-item">
            <label>{t('settings.darkSquares', 'Dark Squares')}:</label>
            <input
              type="color"
              value={customBoardDark}
              onChange={(e) => {
                setCustomBoardDark(e.target.value);
                setUseCustomBoard(true);
              }}
            />
            <span className="color-value">{customBoardDark}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BoardThemeSelector;
